import React from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { ProgramContainer } from "../../entities/formTemplateDataType";
import { DialogBase } from "./DialogBase";
import { DialogForDateComponent } from "./DialogforDateComponent";
import { DialogForDateRangeComponent } from "./DialogForDateRangeComponent";
import { DialogForReadonlyComponent } from "./DialogforReadonlyComponent";
import { DialogForTableRuleComponent } from "./DialogforTableRuleComponent";
import { DialogForTextComponent } from "./DialogforTextComponent";
import { DialogForDefaultComponent } from "./DialogforDefaultComponent";
import { DialogforExcelComponent } from "./DialogforExcelComponent";
import { DialogForLabelComponent } from "./DialogforLabelComponent";
import { DialogForButtonComponent } from "./DialogForButtonComponent";
import { DialogForDateTimeComponent } from "./DialogforDateTimeComponent";
import { DialongforAddressComponent } from "./DialogforAddressComponent";
import { DialogForFileComponent } from "./DialogForFileComponent";
import { DialogForFeedbackComponent } from "./DialogforFeedbackComponent";
import { DialogForCheckPlateAndRenderImageComponent } from "./DialogForCheckPlateAndRenderImageComponent";
import { DialogForInquireAndRedirectComponent } from "./DialogForInquireAndRedirectComponent";
import { DialogForOrderConfirmationComponent } from "./DialogForOrderConfirmation";
import { DialogForIncidentReportConfirmationComponent } from "./DialogForIncidentReportConfirmation";
import DialoagForCardButtonComponent from "./DialogForCardButtonComponent";
import { DialogCardDesignComponent } from "./DialogCardDesignComponent";
import { getRootComponent } from "../../utilities/ElementUtils";
import { DialongforLicensePlate } from "./DialogforLicensePlate";
import { DialogForGoogleMapComponent } from "./DialogForGoogleMapComponent";
import { DialogForDropdownComponent } from "./DialogforDropdownComponent";
import { DialogForPagedSummaryListComponent } from "./DialogForPagedSummaryListComponent";
import { DialogForDynamicAccordionFormComponent } from "./DialogForDynamicAccordionFormComponent";
import { DialogForSearchSingleItemFromApiComponent } from "./DialogForSearchSingleItemFromApiComponent";
import { DialogForTileSelectionComponent } from "./DialogForTileSelectionComponent";
import { DialogForReportDataTableComponent } from "./DialogForReportDataTableComponent";
import { DialogForOrderBreakdownComponent } from "./DialogForOrderBreakdownComponent";

interface Props {
    ele;
    isEng: boolean;
    callback: (programContainer: ProgramContainer)=> void;
}

interface State {
    dateDialogVisible: boolean
    dateRangeDialogVisible: boolean
    dateTimeDialogVisible: boolean
    readonlyDialogVisible: boolean
    tableRuleDialogVisible: boolean
    textDialogVisible: boolean
    defaultDialogVisible: boolean;
    excelDialogVisible: boolean;
    confirmDialogVisible: boolean;
    labelDialogVisible:boolean;
    buttonDialogVisible:boolean;
    addressDialogVisible:boolean;
    fileDialogVisible:boolean;
    feedbackDialogVisible:boolean;
    checkPlateAndRenderImageDialogVisible: boolean;
    inquireAndRedirectDialogVisible: boolean;
    orderConfirmationDialogVisible: boolean;
    incidentReportConfirmationDialogVisible: boolean;
    cardButtonDialogVisible: boolean;
    cardDialogVisible: boolean;
    licensePlateDialogVisible: boolean;
    googleMapDialogVisible: boolean;
    dropdownDialogVisible: boolean;
    pagedSummaryListDialogVisible: boolean;
    dynamicAccordionFormDialogVisible: boolean;
    searchSingleItemFromApiDialogVisible: boolean;
    tileSelectionDialogVisible: boolean;
    reportDataTableDialogVisible: boolean;
    orderBreakdownDialogVisible: boolean;
}

export class MoreButtonComponent extends DialogBase<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            dateDialogVisible: false,
            dateRangeDialogVisible: false,
            dateTimeDialogVisible: false,
            readonlyDialogVisible: false,
            tableRuleDialogVisible: false,
            textDialogVisible: false,
            defaultDialogVisible: false,
            excelDialogVisible: false,
            confirmDialogVisible: false,
            labelDialogVisible:false,
            buttonDialogVisible:false,
            addressDialogVisible:false,
            fileDialogVisible:false,
            feedbackDialogVisible:false,
            checkPlateAndRenderImageDialogVisible: false,
            inquireAndRedirectDialogVisible: false,
            orderConfirmationDialogVisible: false,
            incidentReportConfirmationDialogVisible: false,
            cardButtonDialogVisible: false,
            cardDialogVisible: false,
            licensePlateDialogVisible: false,
            googleMapDialogVisible: false,
            dropdownDialogVisible: false,
            pagedSummaryListDialogVisible: false,
            dynamicAccordionFormDialogVisible: false,
            searchSingleItemFromApiDialogVisible: false,
            tileSelectionDialogVisible: false,
            reportDataTableDialogVisible: false,
            orderBreakdownDialogVisible: false
        }
    }

    generateHtmlString = () => {
        let p = this.props.ele;
        return (
            <div key={"buttonpanel_" + p.Sequence} className="button-panel-container">
                <div
                    style={{ display: p.Sequence == 1 ? "none" : "block" }}
                    className="panel-button"
                    key={"moveup_" + p.Id}
                    onClick={(e) => {
                        p.parent.ListOfFormSectionElements[p.Sequence - 2].Sequence =
                            p.parent.ListOfFormSectionElements[p.Sequence - 2].Sequence + 1;
                        p.Sequence = p.Sequence - 1;
                        this.props.callback(getRootComponent(p));
                    }}
                >
                    Move Up
                </div>
                <div
                    style={{
                        display:
                            p.Sequence == p.parent.ListOfFormSectionElements.length
                                ? "none"
                                : "block",
                    }}
                    className="panel-button"
                    onClick={(e) => {
                        p.parent.ListOfFormSectionElements[p.Sequence].Sequence =
                            p.parent.ListOfFormSectionElements[p.Sequence].Sequence - 1;
                        p.Sequence = p.Sequence + 1;
                        this.props.callback(getRootComponent(p));
                    }}
                >
                    Move Down
                </div>
                <div className="panel-button" onClick={() => this.showConfirmation()}>
                    Remove
                </div>
                <div
                    className="panel-button"
                    onClick={() => {
                        if (this.props.ele.Editable == "Y" || this.props.ele.Datatype == "Table" || this.props.ele.Datatype == "DynamicAccordionForm") {
                            switch (this.props.ele.Datatype) {
                                case "Date":
                                case "ODSDate":
                                    this.setState({ dateDialogVisible: true });
                                    break;
                                case "ODSDateRange":
                                    this.setState({ dateRangeDialogVisible: true });
                                    break;
                                case "DateTime":
                                    this.setState({ dateTimeDialogVisible: true });
                                    break;
                                case "Table":
                                case "Excel Template":
                                    this.setState({ tableRuleDialogVisible: true });
                                    break;
                                case "Text":
                                case "Email":
                                case "MultiText":
                                    this.setState({ textDialogVisible: true });
                                    break;

                                case "Excel":
                                    this.setState({ excelDialogVisible: true });
                                    break;
                                case "Label":
                                        this.setState({ labelDialogVisible: true });
                                        break;
                                case "Button":
                                case "PdfButton":
                                case "RecaptchaButton":
                                case "PublicSecureButton":
                                case "EditSubsectionButton":
                                    this.setState({ buttonDialogVisible: true });
                                    break;
                                case "CardButton":
                                    this.setState({ cardButtonDialogVisible: true });
                                    break;
                                case "Address":
                                    this.setState({addressDialogVisible:true});
                                    break;
                                case "File":
                                    this.setState({fileDialogVisible:true});
                                    break;
                                case "Feedback":
                                case "TechError":
                                    this.setState({feedbackDialogVisible:true});
                                    break;
                                case "CheckPlateAndRenderImage":
                                    this.setState({checkPlateAndRenderImageDialogVisible: true});
                                    break;
                                case "InquireAndRedirect":
                                    this.setState({inquireAndRedirectDialogVisible: true});
                                    break;
                                case "OrderConfirmation":
                                    this.setState({orderConfirmationDialogVisible: true});
                                    break;
                                case "IncidentReportConfirmation":
                                    this.setState({incidentReportConfirmationDialogVisible: true});
                                    break;
                                case "Card":
                                    this.setState({ cardDialogVisible: true });
                                    break;
                                case "LicensePlate":
                                    this.setState({licensePlateDialogVisible: true});
                                    break;
                                case "GoogleMap":
                                    this.setState({ googleMapDialogVisible: true });
                                    break;
                                case "Dropdown":
                                    this.setState({ dropdownDialogVisible: true });
                                    break;
                                case "PagedSummaryList":
                                    this.setState({ pagedSummaryListDialogVisible: true });
                                    break;
                                case "DynamicAccordionForm":
                                    this.setState({ dynamicAccordionFormDialogVisible: true });
                                    break;
                                case "SearchSingleItemFromApi":
                                    this.setState({ searchSingleItemFromApiDialogVisible: true });
                                    break;
                                case "TileSelection":
                                    this.setState({ tileSelectionDialogVisible: true });
                                    break;
                                case "ReportDataTable":
                                    this.setState({ reportDataTableDialogVisible: true });
                                    break;
                                case "OrderBreakdown":
                                    this.setState({orderBreakdownDialogVisible: true});
                                    break;
                                default:
                                    this.setState({ defaultDialogVisible: true });
                            }
                        } else {
                            this.setState({ readonlyDialogVisible: true });
                        }
                    }}>
                    More...
                </div>
                {/* @ts-ignore */}
                <ConfirmDialog
                    key={"confirmDialog_"}
                    visible={this.state.confirmDialogVisible}
                    message="Are you sure you want to remove this section?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    acceptLabel="Yes"
                    rejectLabel="No"
                    closable = {false}
                    accept={() => {
                        this.removeSection();
                        this.setState({ confirmDialogVisible: false });
                    }}
                    reject={() => this.setState({ confirmDialogVisible: false })}
                />
            </div>
        );
    };

    showConfirmation = () => {
        this.setState({ confirmDialogVisible: true });
    };

    removeSection = () => {
        let p = this.props.ele;
        const listSection = p.parent.ListOfFormSectionElements.filter(p => p.Sequence!== this.props.ele.Sequence)
        p.parent.ListOfFormSectionElements = listSection;
        this.props.callback(getRootComponent(p));
    };

    render() {
        let basicHtmlString = [];
        basicHtmlString.push(this.generateHtmlString());

        if (this.state.dateDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' && this.props.ele.Datatype === 'Date' ? 'block' : 'none' }}>
                    <DialogForDateComponent  key={"Date_"} ele={this.props.ele} dialogVisible={this.state.dateDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ dateDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>

                    </DialogForDateComponent>
                </div>
            )
        }
        if (this.state.dateRangeDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' && this.props.ele.Datatype === 'ODSDateRange' ? 'block' : 'none' }}>
                    <DialogForDateRangeComponent key={"DateRange_"} ele={this.props.ele} dialogVisible={this.state.dateRangeDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ dateRangeDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForDateRangeComponent>
                </div>
            )
        }
        if (this.state.dateTimeDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' &&  this.props.ele.Datatype === 'DateTime' ? 'block' : 'none' }}>
                    <DialogForDateTimeComponent  key={"Date_"} ele={this.props.ele} dialogVisible={this.state.dateTimeDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ dateTimeDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>

                    </DialogForDateTimeComponent>
                </div>
            )
        }
        if (this.state.textDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' && (this.props.ele.Datatype === 'Text' || this.props.ele.Datatype === 'MultiText') ? 'block' : 'none' }}>
                    <DialogForTextComponent  key={"Text_"} ele={this.props.ele} dialogVisible={this.state.textDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ textDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>

                    </DialogForTextComponent>
                </div>
            )
        }
        
        if (this.state.buttonDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: (this.props.ele.Datatype === 'Button' || this.props.ele.Datatype === 'PdfButton') ? 'block' : 'none' }}>
                    <DialogForButtonComponent  key={`button_${this.props.ele.Id} `} ele={this.props.ele} dialogVisible={this.state.buttonDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ buttonDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>

                    </DialogForButtonComponent>
                </div>
            )
        }

        if (this.state.cardButtonDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'CardButton' ? 'block' : 'none' }}>
                    <DialoagForCardButtonComponent  key={`cardButton_${this.props.ele.Id} `} ele={this.props.ele} dialogVisible={this.state.cardButtonDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ cardButtonDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>

                    </DialoagForCardButtonComponent>
                </div>
            );
        }

        if (this.state.defaultDialogVisible) {
            if(this.props.ele.Datatype=="Row"){
                // if(this.props.ele.ListOfFormSubSections!=null)
            }

            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable == 'Y' ? 'block' : 'none' }}>
                    <DialogForDefaultComponent  key={"Default_"} ele={this.props.ele} dialogVisible={this.state.defaultDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ defaultDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>

                    </DialogForDefaultComponent>
                </div>
            )
        }

        if (this.state.readonlyDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForReadonlyComponent  key={"Readonly_"} ele={this.props.ele} dialogVisible={this.state.readonlyDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ readonlyDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForReadonlyComponent>
                </div>
            )
        }

        if (this.state.tableRuleDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForTableRuleComponent key={"TableDialog_"} ele={this.props.ele} dialogVisible={this.state.tableRuleDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ tableRuleDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForTableRuleComponent>
                </div>
            )
        }

        if (this.state.excelDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogforExcelComponent key={"TableExcel_"} ele={this.props.ele} dialogVisible={this.state.excelDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ excelDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogforExcelComponent>
                </div>
            )
        }
        if (this.state.labelDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForLabelComponent key={"lable_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.labelDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ labelDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForLabelComponent>
                </div>
            )
        }
        if (this.state.addressDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialongforAddressComponent key={"lable_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.addressDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ addressDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialongforAddressComponent>
                </div>
            )
        }

        if (this.state.fileDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForFileComponent key={"lable_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.fileDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ fileDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForFileComponent>
                </div>
            )
        }

        if (this.state.feedbackDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForFeedbackComponent key={"feedback_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.feedbackDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ feedbackDialogVisible: false });
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForFeedbackComponent>
                </div>
            )
        }
        if (this.state.cardDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogCardDesignComponent key={"card_dialog_" + this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.cardDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ cardDialogVisible: false });
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogCardDesignComponent>
                </div>
            )
        }
        if (this.state.checkPlateAndRenderImageDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForCheckPlateAndRenderImageComponent key={"feedback_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.checkPlateAndRenderImageDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ checkPlateAndRenderImageDialogVisible: false });
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForCheckPlateAndRenderImageComponent>
                </div>
            )
        }
        
        if (this.state.inquireAndRedirectDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'Button' ? 'block' : 'none' }}>
                    <DialogForInquireAndRedirectComponent  key={`button_${this.props.ele.Id} `} ele={this.props.ele} dialogVisible={this.state.inquireAndRedirectDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ inquireAndRedirectDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForInquireAndRedirectComponent>
                </div>
            )
        }
        
        if (this.state.orderConfirmationDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'Button' ? 'block' : 'none' }}>
                    <DialogForOrderConfirmationComponent  key={`button_${this.props.ele.Id} `} ele={this.props.ele} dialogVisible={this.state.orderConfirmationDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ orderConfirmationDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForOrderConfirmationComponent>
                </div>
            )
        }

        if (this.state.incidentReportConfirmationDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'Button' ? 'block' : 'none' }}>
                    <DialogForIncidentReportConfirmationComponent  key={`incident_report_${this.props.ele.Id} `} ele={this.props.ele} dialogVisible={this.state.incidentReportConfirmationDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ incidentReportConfirmationDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForIncidentReportConfirmationComponent>
                </div>
            )
        }

        if(this.state.licensePlateDialogVisible){
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialongforLicensePlate key={"lable_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.licensePlateDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ licensePlateDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialongforLicensePlate>
                </div>
            )
        }

        if (this.state.googleMapDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'GoogleMap' ? 'block' : 'none' }}>
                    <DialogForGoogleMapComponent 
                        key={`googleMap_${this.props.ele.Id}`} 
                        ele={this.props.ele} 
                        dialogVisible={this.state.googleMapDialogVisible} 
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ googleMapDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForGoogleMapComponent>
                </div>
            )
        }

        if (this.state.dropdownDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'Dropdown' ? 'block' : 'none' }}>
                    <DialogForDropdownComponent
                        key={`dropdown_${this.props.ele.Id}`}
                        ele={this.props.ele}
                        dialogVisible={this.state.dropdownDialogVisible}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ dropdownDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForDropdownComponent>
                </div>
            )
        }

        if (this.state.pagedSummaryListDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'PagedSummaryList' ? 'block' : 'none' }}>
                    <DialogForPagedSummaryListComponent
                        key={`pagedSummaryList_${this.props.ele.Id}`}
                        ele={this.props.ele}
                        dialogVisible={this.state.pagedSummaryListDialogVisible}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ pagedSummaryListDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForPagedSummaryListComponent>
                </div>
            )
        }

        if (this.state.dynamicAccordionFormDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'DynamicAccordionForm' ? 'block' : 'none' }}>
                    <DialogForDynamicAccordionFormComponent
                        key={`dynamicAccordionForm_${this.props.ele.Id}`}
                        ele={this.props.ele}
                        dialogVisible={this.state.dynamicAccordionFormDialogVisible}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ dynamicAccordionFormDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForDynamicAccordionFormComponent>
                </div>
            )
        }

        if (this.state.searchSingleItemFromApiDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'SearchSingleItemFromApi' ? 'block' : 'none' }}>
                    <DialogForSearchSingleItemFromApiComponent
                        key={`searchSingleItemFromApi_${this.props.ele.Id}`}
                        ele={this.props.ele}
                        dialogVisible={this.state.searchSingleItemFromApiDialogVisible}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ searchSingleItemFromApiDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForSearchSingleItemFromApiComponent>
                </div>
            )
        }

        if (this.state.tileSelectionDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'TileSelection' ? 'block' : 'none' }}>
                    <DialogForTileSelectionComponent
                        key={`tileSelection_${this.props.ele.Id}`}
                        ele={this.props.ele}
                        dialogVisible={this.state.tileSelectionDialogVisible}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ tileSelectionDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForTileSelectionComponent>
                </div>
            )
        }

        if (this.state.reportDataTableDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Datatype === 'ReportDataTable' ? 'block' : 'none' }}>
                    <DialogForReportDataTableComponent
                        key={`reportDataTable_${this.props.ele.Id}`}
                        ele={this.props.ele}
                        dialogVisible={this.state.reportDataTableDialogVisible}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ reportDataTableDialogVisible: false })
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForReportDataTableComponent>
                </div>
            )
        }

        if (this.state.orderBreakdownDialogVisible) {
            basicHtmlString.push(
                <div style={{ display: this.props.ele.Editable !== 'Y' ? 'block' : 'none' }}>
                    <DialogForOrderBreakdownComponent key={"orderBreakdown_dialog_"+ this.props.ele.Sequence} ele={this.props.ele} dialogVisible={this.state.orderBreakdownDialogVisible} isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.setState({ orderBreakdownDialogVisible: false });
                            }
                            this.props.callback(getRootComponent(this.props.ele));
                        }}>
                    </DialogForOrderBreakdownComponent>
                </div>
            )
        }

        return (
            basicHtmlString
        )
    }
}
